import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

import { SeguridadService } from '../../../src/app/shared/services';
import { GastoAdjuntoPublicoQrResponseDto } from '../../../src/app/shared/model';

@Component({
    selector: 'app-expensaPublic',
    templateUrl: './expensaPublic.component.html',
    styleUrls: ['./expensaPublic.component.css']
})

export class ExpensaPublicComponent implements OnInit {
    
    item: GastoAdjuntoPublicoQrResponseDto;

    isValidating: boolean = false;
    isValid: boolean = false;

    msgError: string = "";

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private seguridadService: SeguridadService
    ) {
    }

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            if (params['tk'] != null && params['tk'].length > '0') {
                this.isValidating = true;
                this.seguridadService.processExpenseToken(params['tk']).subscribe(response => {
                    this.isValidating = false;
                    
                    if (response && response.Success) {
                        this.isValid = true;
                        this.item = response.Result;
                    }
                    else {
                        this.isValid = false;
                        this.msgError = "Ocurrió un error llevando a cabo la operación.";
                    }
                }, 
                (err: HttpErrorResponse) => {
                    this.isValidating = false;
                    this.msgError = err?.error?.Message ?? "Ocurrió un error solicitando los datos al servidor.";
                    // this.sharedFunctions.handleError(err, true);
                });
            }
            else {
                this.isValid = false;
                this.msgError = "La URL no es válida";
                // this.sharedFunctions.showMessage("La URL no es válida", "Error");
            }
        });
    }

    onCancelar() {
        this.router.navigate(['auth/login']);
    }
}